import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

import FloatingSidebar from "../../widgets/Sidebar/FloatingSidebar";
import {
  MANAGE_HOME_NAV_CONFIG,
  MANAGE_HOME_NAV_ITEM_IDS,
} from "../../constants/constants";
import styles from "./ManageHomeLayout.module.scss";


const NAV_ICONS = {
  [MANAGE_HOME_NAV_ITEM_IDS.STUDENT]: SchoolOutlinedIcon,
  [MANAGE_HOME_NAV_ITEM_IDS.AGENT]: PersonOutlineIcon,
};

const items = MANAGE_HOME_NAV_CONFIG.map((item) => ({
  ...item,
  icon: NAV_ICONS[item.id],
}));

const getActiveNavItemId = (pathname) => {
  if (!pathname) return null;

  const activeItem = items.find((item) => {
    if (!item) return false;
    if (!item.path) return false;
    return pathname.startsWith(item.path);
  });

  if (!activeItem) return null;

  return activeItem.id;
};


const ManageHomeLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const activeItemId = getActiveNavItemId(location.pathname);

  const handleItemSelect = (item) => {
    if (!item) return;
    if (!item.path) return;
    if (item.path === location.pathname) return;

    navigate(item.path);
  };

  const handleToggleCollapse = () => {
    setCollapsed((previousCollapsed) => !previousCollapsed);
  };

  const contentClassName = collapsed
    ? `${styles.content} ${styles.contentCollapsed}`
    : `${styles.content} ${styles.contentExpanded}`;

  return (
    <div className={styles.layout}>
      <FloatingSidebar
        title="Manage"
        items={items}
        activeItemId={activeItemId}
        onItemSelect={handleItemSelect}
        collapsed={collapsed}
        onToggleCollapse={handleToggleCollapse}
      />
      <div className={contentClassName}>
        <Outlet />
      </div>
    </div>
  );
};

export default ManageHomeLayout;
